<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-lock`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M35 15c0-6.075-4.925-11-11-11S13 8.925 13 15v4H6a2 2 0 00-2 2v21a2 2 0 002 2h36a2 2 0 002-2V21a2 2 0 00-2-2h-7v-4zM8 40V23h32v17H8zm17-14a1 1 0 011 1v9a1 1 0 01-1 1h-2a1 1 0 01-1-1v-9a1 1 0 011-1h2zm-8-11a7 7 0 1114 0v4H17v-4z"/></svg>
</template>
<script>

export default {
  name: 'IconLock',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
